import React from "react";
import {Get} from "../components/request";
import {isEmpty} from "lodash";
import {Alert, Button, Collapse} from "react-bootstrap";
import screens from "../screens";
import ScreenComponent from "../components/screenComponent";
import {withRouter} from "react-router-dom";

class Valves extends ScreenComponent {
    constructor(props) {
        super(props);
        this.state = {
            valves: []
        }
    }

    async componentDidMount() {
        super.componentDidMount();

        const {body} = await Get(`/v1/extranet/student/${screens.Dashboard}01`);
        let valves = body.slice();

        await Promise.all(
            valves.map(async (item) => {
                let {body} = await Get(`/v1/extranet/student/${screens.Dashboard}01/${item.AnnonceID}`);
                item.pj = body;
            })
        );

        valves.sort((a, b) => (a.AnnonceDateDebutPublication < b.AnnonceDateDebutPublication) ? 1 : -1);

        this.setState({
            valves: valves
        });
    }

    renderValves() {
        return (
            <>
                {this.state.valves.map((m, key) => {
                        return <Alert key={key} variant={m.PrioriteAnnonce === "Urgente" ? "danger" : "secondary"}>
                            <Alert.Heading>{m.AnnonceLibelle}</Alert.Heading>
                            <hr/>
                            <div>
                                <Collapse className="readMore" timeout={60 * 20} in={m.open}>
                                    <div>
                                        {m.AnnonceTexteComplet}
                                        <div>

                                            {m.pj.map((pj, pjKey) => {
                                                return <Button key={pjKey} className={"mx-3 mt-5 mb-3"} size={"lg"}
                                                               target={"_blank"}
                                                               href={`${process.env.APP_API_ENDPOINT}/v1/files/${pj.PieceJointeFichierID}`}>{pj.PieceJointeFichierNom}</Button>
                                            })}

                                        </div>
                                    </div>
                                </Collapse>
                                {/* eslint-disable-next-line */}
                                <a
                                    onClick={() => {
                                        let valves = [...this.state.valves];
                                        valves[key].open = !valves[key].open;
                                        this.setState({valves});
                                    }}
                                    aria-controls="example-collapse-text"
                                    aria-expanded={m.open}
                                >{m.open ? " - Lire moins" : " + Lire plus"}</a>
                            </div>
                            <blockquote className="text-right mb-0 mt-2">
                                <footer
                                    className="blockquote-footer">{new Date(m.AnnonceDateDebutPublication).toLocaleDateString()}</footer>
                            </blockquote>
                        </Alert>
                    }
                )}
            </>
        )
    }

    render() {
        return (
            <section>
                {!isEmpty(this.state.valves) ? this.renderValves() : ""}
            </section>
        )
    }
}

export default withRouter(Valves);